import React from 'react'
import { useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import WhatsAppIcon from 'components/icons/whatsapp_icon.svg'
import sx from './styles'

const EasyButton = ({
  color = 'secondary', cta, showIcon = true, handleClick,
}) => {
  const { formatMessage: f } = useIntl()

  return (
    <Button
      className="cta_easy_1"
      sx={sx.mainButtom}
      variant="easy"
      color={color}
      onClick={handleClick}
      endIcon={showIcon && <WhatsAppIcon />}
      aria-label={f({ id: cta })}
    >
      {f({ id: cta })}
    </Button>
  )
}

export default EasyButton
